module.exports = __webpack_public_path__ + "img/img_sp_thum.b235e692.png";